import { FC } from 'react'

import { Card, FeedItem } from '@forto-dev/phoenix-ui-core'
import { renderer } from '@forto-dev/renderer-phoenix-ui'

import { InsightActivityContent } from '@/features/feed/view/InsightActivityContent'
import { useLocalisation } from '@/utils/localisation'

import { ActivityFeedItemProps } from './types'
import { useRendererSDKContext } from '../hooks/useRendererSDKContext'

export const ActivityFeedItemDeviationRiskInsight: FC<ActivityFeedItemProps> = ({ item, status, v2Flow }) => {
  const { translate, translateDate, currentLanguage } = useLocalisation()
  const { rendererContext } = useRendererSDKContext({ item, channel: 'feed', renderType: 'activity' })

  const title = rendererContext && renderer.renderSubject(rendererContext.componentComposition.title, currentLanguage)

  return (
    <FeedItem
      type="warning"
      title={title || translate('feed.list.DeviationRiskInsight.action')}
      date={translateDate('feed_date', item.activity.createdAt)}
      suffix={item.activity.actor.type === 'Service' ? translate('feed.suffix.automated') : undefined}
      status={status}
    >
      <a id={`feed-activity-${item.id}`} />
      <Card>
        <InsightActivityContent item={item} v2Flow={v2Flow} />
      </Card>
    </FeedItem>
  )
}
